export enum RequestQueryKeysE {
  FetchTickets = 'fetchTickets',
  FetchTicket = 'fetchTicket',
  FetchTicketAttachments = 'fetchTicketAttachments',
  FetchTicketMessages = 'fetchTicketMessages',
  CreateTicket = 'createTicket',
  CreateTicketMessage = 'createTicketMessage',
  CreateTicketScreenshotMessage = 'createTicketScreenshotMessage',
  CreateTicketAttachment = 'createTicketAttachment',
  CreateTicketMultiAttachment = 'createTicketMultiAttachment',
  CreateTicketMultiPartAttachmentInitiate = 'createTicketMultiPartAttachmentInitiate',
  CreateTicketMultiPartAttachmentUpload = 'createTicketMultiPartAttachmentUpload',
  CreateTicketMultiPartAttachmentComplete = 'createTicketMultiPartAttachmentComplete',
  ReopenTicket = 'reopenTicket',
  ApproveTicket = 'approveTicket',
  CloseTicket = 'closeTicket',
  FetchTicketsCountByRoofTop = 'fetchTicketsCountByRoofTop',
  FetchUserAuthTokens = 'fetchUserAuthTokens',
  FetchTicketRequestCategories = 'fetchTicketRequestCategories',
  FetchTicketRequestSubcategories = 'fetchTicketRequestSubcategories',
  FetchClaimStatuses = 'fetchClaimStatuses',
  FetchPriorities = 'fetchPriorities',
  ChangeTicketClaimStatus = 'changeTicketClaimStatus',
  ChangeTicketSubcategory = 'changeTicketSubCategoryId',
  ChangeTicketPriority = 'changeTicketPriority',
  ChangeTicketReadStatus = 'changeTicketReadStatus',
  ChangeTicketUnreadStatus = 'changeTicketUnreadStatus',
  FetchAvailableFileTypes = 'fetchAvailableFileTypes',
  FetchUser = 'fetchUser',
  UpdateUser = 'updateUser',
  FetchAttachment = 'fetchAttachment',
  FetchViewAttachment = 'fetchViewAttachment',
  DeleteAttachment = 'deleteAttachment',
  GetAttachmentUrl = 'getAttachmentUrl',
  GetAttachmentFromSignedUrl = 'getAttachmentFromSignedUrl',
  FetchTicketsReportLastMonth = 'fetchTicketsReportLastMonth',
  FetchClaimReportCards = 'fetchClaimReportCards',
  FetchGroupedReleaseNotes = 'fetchGroupedReleaseNotes',
  FetchNotificationsHistory = 'fetchNotificationsHistory',
  UpdateNotificationHistoryStatus = 'updateNotificationHistoryStatus',
  UpdateNotificationsHistoryStatus = 'updateNotificationsHistoryStatus',
  DeleteTicket = 'deleteTicket',
  FetchBannerMessages = 'fetchBannerMessages',
  FetchRepairOrder = 'fetchRepairOrder',
  FetchUserColumnPreferences = 'fetchUserColumnPreferences',
  UpdateUserColumnPreferences = 'updateUserColumnPreferences',
  ChirpTicketDetailsChange = 'changeTicketDetails',
  ExportTickets = 'exportTickets',
  FetchLatestReleaseNote = 'fetchLatestReleaseNote',
  GetRooftopFeatures = 'getRooftopFeatures',
  FetchMappedRooftopsList = 'fetchMappedRooftopsList',
}

export enum RequestStaleTimeE {
  GroupedReleaseNotes = 300000,
  TicketsReportLastMonth = 300000,
  ClaimReportCards = 300000,
  TicketRequestCategories = 60000,
  ClaimStatuses = 60000,
  Priorities = 60000,
  Tickets = 60000,
  Ticket = 60000,
  TicketsCountByRoofTop = 60000,
  TicketAttachments = 60000,
  TicketMessages = 60000,
  UserProfile = 300000,
}
